
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TABS_CONFIG} from '@angular/material/tabs';
import { MatPaginatorIntl} from '@angular/material/paginator';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { getSwePaginatorIntl } from './classes/swe-paginator-intl';
import { CustomDateAdapter } from './classes/custom-date-adapter';
import { SHARED_MATERIAL } from './shared-material';

@NgModule({
    imports: [
        SHARED_MATERIAL
    ],
    exports: [
        SHARED_MATERIAL
    ],  
    providers: [
        MatDatepickerModule,
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
        { provide: MAT_TABS_CONFIG, useValue: { stretchTabs: false } },
        { provide: MatPaginatorIntl, useValue: getSwePaginatorIntl() },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: LOCALE_ID, useValue: "sv-SE" },
        { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },

    ]
})

export class MaterialModule { }